import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { DateFormatter } from '@repo/toolkit/date'
import { NumberFormatter } from '@repo/toolkit/number'
import Badge from '@repo/ui/badge'
import Typography from '@repo/ui/typography'
import { compareDesc, parseISO } from 'date-fns'

import { CenterOlPaymentTypeEnum } from '../../../lib/types/enums/center-ol-payment/center-ol-payment-type.enum'
import { CenterPayment } from '../../../lib/types/models/center/center'

function PaymentBadge({ payment }: { payment: CenterPayment['centerBankPayments'][number] }) {
  return (
    <Badge
      text={
        <div className="flex items-center gap-1">
          <Typography
            variant="label-semibold"
            color={
              payment.validatedAt ? tailwindColors.green.DEFAULT : tailwindColors.orange.DEFAULT
            }
          >
            {NumberFormatter.formatCurrency(payment.amount, payment.currency)}
          </Typography>
          -
          <Typography variant="label-semibold" color={tailwindColors.grey.lighter}>
            {DateFormatter.DDMMYYYY(payment.dateOfPayment)}
          </Typography>
        </div>
      }
    />
  )
}

export function DisplayPayments({
  payments,
  type
}: {
  payments: CenterPayment['centerBankPayments']
  type: CenterOlPaymentTypeEnum
}) {
  // filter payments by type and sort them by date (newest first)
  const filteredPayments = (payments ?? [])
    .filter((p) => p.type === type)
    .sort((a, b) => compareDesc(parseISO(b.dateOfPayment), parseISO(a.dateOfPayment)))

  if (!filteredPayments || filteredPayments.length === 0)
    return <div className="text-center">-</div>
  return (
    <div className="flex flex-col gap-1 py-2">
      {filteredPayments.map((payment) => (
        <PaymentBadge payment={payment} key={payment.id} />
      ))}
    </div>
  )
}
